module.exports = __webpack_public_path__ + "static/media/cover10.94db1859.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/cover10.png
// module id = 563
// module chunks = 0